(function () {
  console.log('%c[bundle-checkout] build=2026-07-15-v10-metaobject-tiers', 'color:#fff;background:#000;padding:2px 6px;border-radius:3px');
  // Matches any HBUNDLE-family code (HBUNDLE_T1…, plus legacy HBUNDLE8/15/20 stuck in old carts).
  const BUNDLE_CODE_RE = /^HBUNDLE/i;
  let busy = false;

  // Pick the discount CODE for the current cart from window.HULU_BUNDLE_TIERS (rendered from the
  // bundle_config metaobject in theme.liquid). Returns the code of the highest tier whose
  // accessory-count threshold is met, else null. No percentages here — the % lives on the Shopify
  // discount of each code, so changing a tier's discount amount never touches this file.
  function deriveTierCode(cart) {
    const tiers = Array.isArray(window.HULU_BUNDLE_TIERS) ? window.HULU_BUNDLE_TIERS : [];
    if (!tiers.length) return null;
    const accessoryCount = (cart.items || []).reduce((sum, i) => {
      const role = i.properties && i.properties._bundle_role;
      return role === 'accessory' ? sum + (i.quantity || 1) : sum;
    }, 0);
    let picked = null;
    for (const t of tiers) {
      if (t && typeof t.qty === 'number' && t.code && accessoryCount >= t.qty) {
        if (!picked || t.qty > picked.qty) picked = t;
      }
    }
    return picked ? picked.code : null;
  }

  async function rebuildCartToStripBundleDiscount(cart) {
    const items = (cart.items || []).map((i) => {
      const out = { id: i.variant_id, quantity: i.quantity };
      if (i.properties && Object.keys(i.properties).length) out.properties = i.properties;
      if (i.selling_plan_allocation && i.selling_plan_allocation.selling_plan) {
        out.selling_plan = i.selling_plan_allocation.selling_plan.id;
      }
      return out;
    });
    const note = cart.note || null;
    const attributes = Object.assign({}, cart.attributes || {});
    delete attributes.bundle_discount_pct;

    // Delete cart cookie to force a brand-new cart token. /cart/clear.js was tested and
    // does NOT strip discount_codes (only clears line items, token+codes persist). The
    // only reliable way to remove a sticky HBUNDLE applied via ?discount= URL is to
    // get a new cart token. Verified 2026-05-07: token changes, discount_codes empty.
    document.cookie = 'cart=; Max-Age=0; path=/';

    if (items.length) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
    }
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note, attributes: attributes }),
    });
  }

  async function go(e) {
    if (busy) return;
    busy = true;
    if (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
    }
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      const attrPct = parseInt(cart?.attributes?.bundle_discount_pct, 10);
      const overrideCode = (cart?.attributes?.bundle_override_code || '').trim();
      const enabled = window.HuluBuluBundleEnabled !== false;
      const hasStickyBundle = (cart?.discount_codes || []).some(
        (d) => d && d.code && BUNDLE_CODE_RE.test(d.code)
      );

      // Code resolution priority:
      //   0. _COMBO_ sentinel — combo codes already persisted in cart by the
      //      /checkout warmup fetch fired at Add-to-cart time. Plain /checkout
      //      navigation hands them off to Shopify checkout natively.
      //   1. _AUTO_ sentinel — Shopify Automatic discount mode; plain /checkout.
      //   2. Code override — apply that specific code via ?discount= URL.
      //   3. HBUNDLE tier from cart accessories count (normal mode).
      let code = null;
      const isComboMode = overrideCode === '_COMBO_';
      const isAutoMode = overrideCode === '_AUTO_' || isComboMode;
      if (enabled && !isAutoMode) {
        if (overrideCode) {
          code = overrideCode;
        } else {
          code = deriveTierCode(cart);
        }
      }

      console.log(
        '[bundle-checkout] go code=' + code +
          ' isComboMode=' + isComboMode +
          ' (overrideCode=' + (overrideCode || 'none') + ', attrPct=' + attrPct + ')' +
          ' enabled=' + enabled +
          ' hasStickyBundle=' + hasStickyBundle
      );

      if (!enabled && hasStickyBundle) {
        console.log('[bundle-checkout] disabled + sticky bundle code → rebuilding cart');
        try {
          await rebuildCartToStripBundleDiscount(cart);
        } catch (rebuildErr) {
          console.warn('[bundle-checkout] cart rebuild failed', rebuildErr);
        }
      }

      window.location.href = code ? '/checkout?discount=' + encodeURIComponent(code) : '/checkout';
    } catch (err) {
      console.warn('[bundle-checkout] error', err);
      window.location.href = '/checkout';
    }
  }

  function isCheckoutForm(form) {
    const action = form.action || '';
    if (action.includes('checkout')) {
      return form.method && form.method.toLowerCase() !== 'get';
    }
    const formId = form.id;
    const btnInside = form.querySelector('button[name="checkout"], input[name="checkout"]');
    const btnExternal = formId
      ? document.querySelector('button[name="checkout"][form="' + formId + '"]')
      : null;
    return !!(btnInside || btnExternal);
  }

  document.addEventListener('submit', function (e) {
    if (!e.target || !isCheckoutForm(e.target)) return;
    console.log('[bundle-checkout] intercepted submit, action=' + (e.target.action || ''));
    go(e);
  }, true);

  document.addEventListener('click', function (e) {
    const el = e.target.closest('a[href*="/checkout"]');
    if (!el) return;
    console.log('[bundle-checkout] intercepted checkout link');
    go(e);
  }, true);

  // ===== Cart-state ↔ discount sync =====
  // Whenever the cart changes (item removed, qty changed, drawer ajax update, page nav),
  // re-derive the correct tier from cart contents and re-apply the right HBUNDLE code.
  // This fixes the case where cart has stale higher-tier sticky (e.g., HBUNDLE20 from
  // earlier 3-accessory state) but customer removed an item — without this sync, Shopify
  // would either fall back to a lower tier from cart history or show no discount at all,
  // even though the customer is still entitled to a tier (e.g., HBUNDLE15 for 2 accessories).
  let syncBusy = false;
  async function syncCartDiscount() {
    if (syncBusy) return;
    syncBusy = true;
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      const enabled = window.HuluBuluBundleEnabled !== false;
      const overrideCode = (cart?.attributes?.bundle_override_code || '').trim();

      // Override takes priority over HBUNDLE tier. _AUTO_ = Automatic discount, no code to apply.
      let expectedCode = null;
      const isAutoMode = overrideCode === '_AUTO_' || overrideCode === '_COMBO_';
      if (enabled && !isAutoMode) {
        if (overrideCode) {
          expectedCode = overrideCode;
        } else {
          expectedCode = deriveTierCode(cart);
        }
      }

      // Find any HBUNDLE-family code or the exact override code currently applied
      const allBundleish = (cart.discount_codes || []).filter((d) => d && d.applicable);
      const currentApplicable = allBundleish.find(
        (d) => BUNDLE_CODE_RE.test(d.code) || (overrideCode && d.code === overrideCode)
      );

      // Only re-apply if expected code differs from currently applied
      if (expectedCode && (!currentApplicable || currentApplicable.code !== expectedCode)) {
        console.log(
          '[bundle-checkout] sync: cart needs ' + expectedCode +
            ' (was ' + (currentApplicable ? currentApplicable.code : 'none') + ')'
        );
        await fetch('/discount/' + encodeURIComponent(expectedCode), { credentials: 'same-origin' });
        // Notify any cart UIs to re-render with the new discount applied
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-checkout-sync' });
        } else {
          // Fallback: trigger a soft refresh of cart-displaying elements
          document.dispatchEvent(new CustomEvent('cart:bundle-discount-synced'));
        }
      }
    } catch (e) {
      console.warn('[bundle-checkout] syncCartDiscount failed', e);
    } finally {
      syncBusy = false;
    }
  }

  // ===== Combo net-price quota guard =====
  // A net-price companion (e.g. $20 Pod) is only legitimate while backed by an anchor in the
  // cart. This runs cart-side: per combo, count anchors, and for each companion revert any net
  // units BEYOND the anchor count (or ALL of them when the anchor was removed) back to the
  // public full-price variant of the SAME colour. One mechanism covers both:
  //   • delete anchor  → every net companion reverts to original price
  //   • 1 Pouch + 3 Pod → keep 1 net, revert 2 to full price ("only one discounted")
  // Lock checkout + dynamic payment buttons while the guard is reverting, so a fast user can't
  // hit Checkout mid-revert and carry the un-corrected (net-price over-quota) cart to checkout.
  function setCheckoutBusy(busy) {
    document
      .querySelectorAll('[name="checkout"], #checkout, .cart__checkout-button, .shopify-payment-button')
      .forEach((el) => {
        el.style.pointerEvents = busy ? 'none' : '';
        el.style.opacity = busy ? '0.45' : '';
        el.setAttribute('aria-busy', busy ? 'true' : 'false');
        if (el.tagName === 'BUTTON') el.toggleAttribute('disabled', busy);
      });
  }

  let comboGuardBusy = false;
  async function enforceComboQuota(cartData) {
    if (comboGuardBusy) return;
    const registry = window.HULU_COMBO_REGISTRY;
    if (!Array.isArray(registry) || registry.length === 0) return;
    comboGuardBusy = true;
    try {
      // Use the event's cartData only when it's a FULL cart (cart-items change.js carries one,
      // with item_count). bundle-upsell's add.js payload is NOT a full cart, so we fetch one via
      // POST /cart/update.js (empty body) — POST isn't intercepted by the preview hot-reload shim
      // the way GET *.js is, so this also works inside CLI preview.
      let cart = cartData && typeof cartData.item_count === 'number' && Array.isArray(cartData.items) ? cartData : null;
      if (!cart) {
        cart = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: '{}',
        }).then((r) => r.json());
      }
      const items = cart.items || [];
      const changes = {}; // net line key -> reduced qty
      const addsByPublic = {}; // public variant id -> qty to add back at full price

      registry.forEach((combo) => {
        const anchorIds = combo.anchorProductIds || [];
        const anchorQty = items
          .filter((i) => anchorIds.indexOf(i.product_id) !== -1)
          .reduce((s, i) => s + i.quantity, 0);

        (combo.companions || []).forEach((comp) => {
          const map = comp.netToPublic || {};
          const netIds = Object.keys(map).map(Number);
          const netLines = items.filter((i) => netIds.indexOf(i.variant_id) !== -1);
          const netQty = netLines.reduce((s, i) => s + i.quantity, 0);
          let excess = netQty - Math.min(netQty, anchorQty);
          if (excess <= 0) return;
          for (const line of netLines) {
            if (excess <= 0) break;
            const take = Math.min(line.quantity, excess);
            const pubId = map[line.variant_id];
            changes[line.key] = (changes[line.key] != null ? changes[line.key] : line.quantity) - take;
            addsByPublic[pubId] = (addsByPublic[pubId] || 0) + take;
            excess -= take;
          }
        });
      });

      const adds = Object.keys(addsByPublic);
      const keys = Object.keys(changes);
      if (adds.length === 0 && keys.length === 0) {
        comboGuardBusy = false;
        return;
      }

      // Repaint in place via Dawn's section rendering — NO full page reload.
      // BATCHED: one /cart/add.js for ALL public variants + one /cart/update.js for ALL net
      // reductions (carries sections to repaint). 2 round-trips total instead of one per item.
      console.log('[combo-guard] reverting', { addsByPublic, changes });
      setCheckoutBusy(true); // lock checkout until the cart is corrected + repainted
      const t0 = Date.now();
      const cartItems = document.querySelector('cart-items, cart-drawer-items');
      let sectionsParam = '';
      if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
        try {
          sectionsParam = cartItems.getSectionsToRender().map((s) => s.section).join(',');
        } catch (_) {}
      }

      if (adds.length) {
        const addResp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: adds.map((id) => ({ id: Number(id), quantity: addsByPublic[id] })) }),
        }).then((r) => r.json());
        // If the public variant is out of stock the add fails. Do NOT trim the net lines then —
        // otherwise the item would vanish from the cart entirely. Leave it (briefly over-quota)
        // rather than delete the customer's item. The real fix lands with the inventory Worker.
        if (addResp && (addResp.status || addResp.description)) {
          console.warn('[combo-guard] public add failed (out of stock?) → keep net lines, skip trim', addResp);
          setCheckoutBusy(false);
          comboGuardBusy = false;
          return;
        }
        console.log('[combo-guard] add done @', Date.now() - t0, 'ms');
      }

      const updates = {};
      keys.forEach((k) => { updates[k] = Math.max(0, changes[k]); });
      const updBody = { updates };
      if (sectionsParam) {
        updBody.sections = sectionsParam;
        updBody.sections_url = window.location.pathname;
      }
      const lastState = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updBody),
      }).then((r) => r.json());
      console.log('[combo-guard] update done @', Date.now() - t0, 'ms; repainting');

      // This theme's cart-items has no renderContents(); it repaints via getSectionsToRender()
      // + getSectionInnerHTML(). Use those directly to swap the cart DOM in place.
      const canRepaint =
        cartItems &&
        typeof cartItems.getSectionsToRender === 'function' &&
        typeof cartItems.getSectionInnerHTML === 'function' &&
        lastState && lastState.sections;
      if (canRepaint) {
        try {
          cartItems.getSectionsToRender().forEach((section) => {
            const html = lastState.sections[section.section];
            if (typeof html !== 'string') return;
            const container = document.getElementById(section.id);
            if (!container) return;
            const elementToReplace = container.querySelector(section.selector) || container;
            elementToReplace.innerHTML = cartItems.getSectionInnerHTML(html, section.selector);
          });
          console.log('[combo-guard] repainted in place @', Date.now() - t0, 'ms (no reload)');
          setCheckoutBusy(false); // cart corrected → unlock checkout
        } catch (err) {
          console.warn('[combo-guard] section repaint threw → reload', err);
          window.location.reload();
          return;
        }
        comboGuardBusy = false;
      } else {
        console.warn('[combo-guard] cannot repaint → reload', {
          hasCartItems: !!cartItems,
          hasGetSections: !!(cartItems && cartItems.getSectionsToRender),
          hasSections: !!(lastState && lastState.sections),
        });
        window.location.reload();
      }
    } catch (e) {
      console.warn('[combo-guard] failed', e);
      setCheckoutBusy(false); // never leave checkout locked on error
      comboGuardBusy = false;
    }
  }

  // Combo cart is now owned by combo-cart.js (V2 single-writer orchestrator). The old
  // enforceComboQuota/setCheckoutBusy above are no longer wired in (kept only as dead code,
  // safe to delete later). Here we keep ONLY the legacy HBUNDLE tier sync for old campaign mode.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCartDiscount);
  } else {
    syncCartDiscount();
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const src = event && event.source;
      if (src === 'bundle-checkout-sync') return;
      setTimeout(syncCartDiscount, 200);
    });
  }
})();
